import { graphql } from '@/graphql-setup'

export const CREATE_TIME_ADDON = graphql(`
  mutation CreateTimeAddon($input: CreateTimeAddonInput!) {
    createTimeAddon(input: $input) {
      timeAddon {
        id
      }
    }
  }
`)

export const PATCH_TIME_ADDON = graphql(`
  mutation PatchTimeAddon($id: ID!, $input: PatchTimeAddonInput!) {
    patchTimeAddon(id: $id, input: $input) {
      timeAddon {
        id
      }
    }
  }
`)

export const DELETE_TIME_ADDON = graphql(`
  mutation DeleteTimeAddon($id: ID!) {
    deleteTimeAddon(id: $id) {
      found
      deletedId
    }
  }
`)

export const CREATE_SALARY_GROUP = graphql(`
  mutation CreateSalaryGroup($input: CreateSalaryGroupInput!) {
    createSalaryGroup(input: $input) {
      salaryGroup {
        id
      }
    }
  }
`)

export const PATCH_SALARY_GROUP = graphql(`
  mutation PatchSalaryGroup($id: ID!, $input: PatchSalaryGroupInput!) {
    patchSalaryGroup(id: $id, input: $input) {
      salaryGroup {
        id
      }
    }
  }
`)

export const DELETE_SALARY_GROUP = graphql(`
  mutation DeleteSalaryGroup($id: ID!) {
    deleteSalaryGroup(id: $id) {
      found
      deletedId
    }
  }
`)

export const CREATE_FIXED_HOURLY_ADDON = graphql(`
  mutation CreateFixedHourlyAddon($input: CreateFixedHourlyAddonInput!) {
    createFixedHourlyAddon(input: $input) {
      fixedHourlyAddon {
        id
      }
    }
  }
`)

export const PATCH_FIXED_HOURLY_ADDON = graphql(`
  mutation PatchFixedHourlyAddon(
    $id: ID!
    $input: PatchFixedHourlyAddonInput!
  ) {
    patchFixedHourlyAddon(id: $id, input: $input) {
      fixedHourlyAddon {
        id
      }
    }
  }
`)

export const CREATE_FIXED_SALARY_ADDON = graphql(`
  mutation CreateFixedSalaryAddon($input: CreateFixedSalaryAddonInput!) {
    createFixedSalaryAddon(input: $input) {
      fixedSalaryAddon {
        id
      }
    }
  }
`)

export const PATCH_FIXED_SALARY_ADDON = graphql(`
  mutation PatchFixedSalaryAddon(
    $id: ID!
    $input: PatchFixedSalaryAddonInput!
  ) {
    patchFixedSalaryAddon(id: $id, input: $input) {
      fixedSalaryAddon {
        id
      }
    }
  }
`)

export const DELETE_FIXED_SALARY_ADDON = graphql(`
  mutation DeleteFixedSalaryAddon($id: ID!) {
    deleteFixedSalaryAddon(id: $id) {
      found
      deletedId
    }
  }
`)

export const DELETE_FIXED_SALARY_DAY_ADDON = graphql(`
  mutation DeleteFixedSalaryDayAddon($id: ID!) {
    deleteFixedSalaryDayAddon(id: $id) {
      found
      deletedId
    }
  }
`)

export const CREATE_FIXED_SALARY_DAY_ADDON = graphql(`
  mutation CreateFixedSalaryDayAddon($input: CreateFixedSalaryDayAddonInput!) {
    createFixedSalaryDayAddon(input: $input) {
      fixedSalaryDayAddon {
        id
      }
    }
  }
`)

export const PATCH_FIXED_SALARY_DAY_ADDON = graphql(`
  mutation PatchFixedSalaryDayAddon(
    $id: ID!
    $input: PatchFixedSalaryDayAddonInput!
  ) {
    patchFixedSalaryDayAddon(id: $id, input: $input) {
      fixedSalaryDayAddon {
        id
      }
    }
  }
`)

export const DELETE_FIXED_HOURLY_ADDON = graphql(`
  mutation DeleteFixedHourlyAddon($id: ID!) {
    deleteFixedHourlyAddon(id: $id) {
      found
      deletedId
    }
  }
`)

export const CREATE_TIME_OVERRIDE = graphql(`
  mutation CreateTimeOverride($input: CreateTimeOverrideInput!) {
    createTimeOverride(input: $input) {
      timeOverride {
        id
      }
    }
  }
`)

export const PATCH_TIME_OVERRIDE = graphql(`
  mutation PatchTimeOverride($id: ID!, $input: PatchTimeOverrideInput!) {
    patchTimeOverride(id: $id, input: $input) {
      timeOverride {
        id
      }
    }
  }
`)

export const DELETE_TIME_OVERRIDE = graphql(`
  mutation DeleteTimeOverride($id: ID!) {
    deleteTimeOverride(id: $id) {
      found
      deletedId
    }
  }
`)

export const PATCH_SALARY_BASE_ENTRY = graphql(`
  mutation PatchSalaryBaseEntry($id: ID!, $input: PatchSalaryBaseEntryInput!) {
    patchSalaryBaseEntry(id: $id, input: $input) {
      salaryBaseEntry {
        id
      }
    }
  }
`)

export const CREATE_FIXED_ADDON = graphql(`
  mutation CreateFixedAddon($input: CreateFixedAddonInput!) {
    createFixedAddon(input: $input) {
      fixedAddon {
        id
      }
    }
  }
`)

export const PATCH_FIXED_ADDON = graphql(`
  mutation PatchFixedAddon($id: ID!, $input: PatchFixedAddonInput!) {
    patchFixedAddon(id: $id, input: $input) {
      fixedAddon {
        id
      }
    }
  }
`)

export const DELETE_FIXED_ADDON = graphql(`
  mutation DeleteFixedAddon($id: ID!) {
    deleteFixedAddon(id: $id) {
      found
      deletedId
    }
  }
`)

export const PATCH_WORK_PERIOD = graphql(`
  mutation PatchWorkPeriod($id: ID!, $input: PatchWorkPeriodInput!) {
    patchWorkPeriod(id: $id, input: $input) {
      workPeriod {
        id
        approvedByUser
        approvedByManager
        userComment
        managerComment
        calendarItem {
          id
        }
        salarySetting {
          id
        }
      }
    }
  }
`)

export const TRANSFER_OVERTIME_TO_ABSENCE_HOUR_TRANSACTION = graphql(`
  mutation TransferOvertimeWorkToAbsenceHourTransaction($workPeriod: ID!) {
    transferOvertimeWorkToAbsenceHourTransaction(workPeriod: $workPeriod) {
      success
      workPeriod {
        id
        absenceHourTransaction {
          id
        }
      }
    }
  }
`)

export const LOCK_CALCULATED_SALARY_FOR_USER = graphql(`
  mutation LockUserMonthReport(
    $user: ID!
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
  ) {
    lockUserMonthReport(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
    ) {
      success
    }
  }
`)

export const EXPORT_SALARY_BASE = graphql(`
  mutation ExportSalaryBase(
    $salaryBase: ID!
    $user: ID!
    $exportFormat: ExportFormat!
    $leaderGroups: [ID!]
    $onlyNonExported: Boolean
  ) {
    exportSalaryBase(
      salaryBase: $salaryBase
      user: $user
      exportFormat: $exportFormat
      leaderGroups: $leaderGroups
      onlyNonExported: $onlyNonExported
    ) {
      ok
    }
  }
`)

export const CREATE_SALARY_CORRECTION_MUTATION = graphql(`
  mutation CreateSalaryCorrection($input: CreateSalaryCorrectionInput!) {
    createSalaryCorrection(input: $input) {
      salaryCorrection {
        id
      }
    }
  }
`)

export const PATCH_SALARY_CORRECTION_MUTATION = graphql(`
  mutation PatchSalaryCorrection(
    $id: ID!
    $input: PatchSalaryCorrectionInput!
  ) {
    patchSalaryCorrection(id: $id, input: $input) {
      salaryCorrection {
        id
      }
    }
  }
`)

export const DELETE_SALARY_CORRECTION_MUTATION = graphql(`
  mutation DeleteSalaryCorrection($id: ID!) {
    deleteSalaryCorrection(id: $id) {
      found
      deletedId
    }
  }
`)

export const CREATE_SALARY_COMMENT_MUTATION = graphql(`
  mutation CreateSalaryComment($input: CreateSalaryCommentInput!) {
    createSalaryComment(input: $input) {
      salaryComment {
        id
      }
    }
  }
`)

export const PATCH_SALARY_COMMENT_MUTATION = graphql(`
  mutation PatchSalaryComment($id: ID!, $input: PatchSalaryCommentInput!) {
    patchSalaryComment(id: $id, input: $input) {
      salaryComment {
        id
      }
    }
  }
`)

export const DELETE_SALARY_COMMENT_MUTATION = graphql(`
  mutation DeleteSalaryComment($id: ID!) {
    deleteSalaryComment(id: $id) {
      found
      deletedId
    }
  }
`)
